import ModalViewModel from 'infra/ModalViewModel'
import Job from 'jobs/Job'
import JobStore from 'jobs/JobStore'
import { makeObservable } from 'mobx'
import { task } from 'mobx-task'

/**
 * View model for closing a job.
 */
export default class CloseJobViewModel extends ModalViewModel {
  constructor(
    public job: Job,
    private jobStore: JobStore,
  ) {
    super()
    makeObservable(this)
  }

  /**
   * Submits the request (close job, rate, depends on situation)
   */
  submit = task.resolved(async () => {
    await this.jobStore.close(this.job)

    this.close()
  })
}
